import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const features = ['Limpieza interior profunda', 'Lavado exterior premium', 'Limpieza de llantas y neumáticos', 'Aspirado completo', 'Limpieza de cristales', 'Aromatización profesional', 'Atención personalizada', 'Productos de máxima calidad'];
export function Features() {
  return <section className="py-16 bg-brand-darker relative border-t border-white/5" data-id="element-11">
      <div className="container mx-auto px-4 md:px-6" data-id="element-12">
        <FadeIn className="text-center mb-10" data-id="element-13">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-14">
            ¿Por qué elegir{' '}
            <span className="text-brand-red" data-id="element-15">Morello Detailing</span>?
          </h2>
          <div className="w-24 h-1 bg-brand-red mx-auto" data-id="element-16"></div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-17">
          {features.map((feature, index) => <FadeIn key={index} delay={0.1 * (index % 4)} className="bg-brand-gray/50 border border-white/5 p-6 rounded-sm hover:border-brand-red/30 transition-colors duration-300 flex items-start gap-4 group" data-id="element-18">
              <CheckCircle2 className="w-6 h-6 text-brand-red shrink-0 mt-0.5 group-hover:scale-110 transition-transform duration-300" data-id="element-19" />
              <span className="text-brand-silver font-medium text-lg leading-tight" data-id="element-20">
                {feature}
              </span>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}